import { createSelector } from 'reselect';
import IpcEquipmentPoolsPredesResdesAnalysisReceptaclesColumns
  from '../../containers/IpcEquipmentPoolsPredesResdesAnalysisReceptaclesColumns';
import ReportDefinitions from '../../../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime =
  state => state.reporting.RECEPTACLES_PREDES_RESDES_ANALYSIS.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting.RECEPTACLES_PREDES_RESDES_ANALYSIS.isLoading;

export const getData =
  ReportDefinitions.RECEPTACLES_PREDES_RESDES_ANALYSIS.getDataFunction();

export const getColumns =
  createSelector(getData, IpcEquipmentPoolsPredesResdesAnalysisReceptaclesColumns);
